import { render, staticRenderFns } from "./DetailsAddress.vue?vue&type=template&id=3d4a8e4e&scoped=true"
import script from "./DetailsAddress.vue?vue&type=script&lang=js"
export * from "./DetailsAddress.vue?vue&type=script&lang=js"
import style0 from "./DetailsAddress.vue?vue&type=style&index=0&id=3d4a8e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a8e4e",
  null
  
)

export default component.exports